import { Box, styled } from '@mui/material';

export const ContainerPlanInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

export const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4rem',
  maxWidth: '1000px',
  margin: '40px 0px',

  [theme.breakpoints.down('sm')]: {
    gap: '2rem',
    margin: '40px 20px'
  }
}));

export const TableContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(5)
}));

export const HeaderContainer = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '2rem'
  }
}));

export const HeaderImage = styled('img')(({ theme }) => ({
  width: '280px',
  height: 'auto',

  [theme.breakpoints.down('sm')]: {
    width: '250px'
  }
}));

export const HeaderText = styled('p')(() => ({
  width: '280px',
  textAlign: 'center'
}));
